import React, { useCallback } from 'react';

import type { ListEditorItem } from '../..';
import FlatButton from '../../../general/flatButton';
import CustomListItemContainer from '../custom-list-item-container';

import Modal, { DialogType, Result } from 'bz-core-controls/modal-new/confirmation/stores';

export interface IProps {
  canRemove?: boolean;
  canOrder?: boolean;
  item: ListEditorItem;
  onRemove?: (item: ListEditorItem) => void;
  category: string;
}

const CustomListItemComp: React.FC<IProps> = React.memo(
  ({ canRemove, canOrder, item, onRemove, category }) => {
    const doRemove = useCallback(
      async (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        let message = `Are you sure you want to permanently delete this item?`;
        if (category == 'VREMINDERS_BTYPES') {
          message = `This will remove any reminders assigned and cancel any scheduled message. ${message}`;
        }
        const res = await Modal.open(DialogType.yesno, {
          title: 'Are you sure?',
          contents: message
        });
        if (res === Result.yes) onRemove?.(item);
      },
      [item]
    );

    let remove = <span />;
    if (canRemove) {
      if (item.inUse) remove = <span className="statusLabel">In Use</span>;
      else if (!!onRemove)
        remove = (
          <FlatButton
            className="!text-rose-600 hover:!bg-rose-600 hover:!text-white"
            onClick={doRemove}
          >
            Delete
          </FlatButton>
        );
    }

    return (
      <CustomListItemContainer canOrder={canOrder} id={item.id} value={item.text}>
        {remove}
      </CustomListItemContainer>
    );
  }
);

CustomListItemComp.displayName = 'CustomListItemComp';

export default CustomListItemComp;
